import React, {  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";

function Credentials() {

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Gestión de Acreditaciones</h1>
      <Footer />
    </div>
  );
}

export default Credentials;
